import InputFilter from './InputFilter';


export default class ProximosEstrenosCineFilter {

    constructor(options) {
        const { source, month, genero } = options;

        this.source = source;
        this.filteredSource = source;
        this.month = new InputFilter(month);
        this.genero = new InputFilter(genero);
        this.$errorEmpty = document.querySelector('.errorEmpty');
    }

    setFirstMonth() {
        this.month.options.first('option').prop('selected', 'true');
    }
    setMonth(value) {
        this.month.val(value);
    }

    setGenero(value) {
        this.genero.val(value);
    }

    clear() {
        this.month.val('');
        this.genero.val('');

    }



    fillSearch(hide = true) {
      
        this.filteredSource = this.source;

        if (hide) {
            this.filteredSource.hide();
            this.$errorEmpty.style.display = 'none';
        }

        if (this.month.val()) {
            this.filteredSource = this.filteredSource.filter(`[data-month='${this.month.val()}']`);
        }
        if (this.genero.val() && this.genero.data('all') !== true) {
            this.filteredSource = this.filteredSource.filter(`[data-generos~='${this.genero.val()}']`);
        }

        //Preguntamos si viene vacio el array mostramos mens de empty
        if (this.filteredSource.length <= 0) {
            this.$errorEmpty.style.display = 'block';
        } else {
            this.filteredSource.fadeIn();
        }
    }
}


// WEBPACK FOOTER //
// ./Statics/scripts/Modules/Filters/ProximosEstrenosCineFilter.js